// hooks/useCurrentUser.js
import { useState, useEffect, useRef } from 'react';
import { fetchCurrentUserApi } from '../service/api';

export const useCurrentUser = (userId, apiUrl) => {
  const [currentUser, setCurrentUser] = useState(null);

  // Guard against duplicate in-flight requests (e.g. StrictMode double-invoked
  // mount effects). Only one request is issued at a time for a given user.
  const inFlightRef = useRef(false);

  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return;
      if (inFlightRef.current) return;
      inFlightRef.current = true;
      try {
        const user = await fetchCurrentUserApi(userId, apiUrl);
        setCurrentUser(user);
      } catch (error) {
        console.error("Error fetching current user:", error);
      } finally {
        inFlightRef.current = false;
      }
    };
    fetchUser();
  }, [userId, apiUrl]);

  return { currentUser };
};